import React from 'react'
import {Box, useDisclosure, Text, Stack, Flex, Button} from '../../../../vanilla'
import {Modal} from '../../../../components/modal'
import { Link } from '../../../../components/link'

interface BookingSlotErrorModalProps extends ReturnType<typeof useDisclosure> {
  isValidShippingAddress?: boolean
  statusCode?: string
}

export const BookingSlotErrorModal = (props: BookingSlotErrorModalProps) => {
  return (
    <Modal {...props} size="full-lg" closeIcon={false} allowScroll={true}>
      <Stack width="full" spacing="12px">
        <Box
          paddingX="16px"
          paddingY={['16px', '16px', '24px']}
          borderBottom="1px"
          borderColor="gray200"
        >
          <Text variant="heading3" lineHeight="shorter" display="block" as="span">
            {!(props.isValidShippingAddress) ? 
              "Unavailable address" :
              "Error" 
            }
          </Text>
        </Box>

        <Box paddingX="16px">
          <Text variant="text3">
            {!(props.isValidShippingAddress) ? (
              <>
                Address no longer valid, please go to {" "}
                <Text
                  variant="text3"
                  textDecoration="underline"
                  lineHeight="shorter"
                  as={Link}
                  to="/account"
                  color="gray800"
                >
                  My Account
                </Text>{" "}
                to update your address.
              </>
            ) : (
              `Sorry, your delivery could not be booked. Please try again later. ${props.statusCode && `(${props.statusCode})`}`
            )}
          </Text>
        </Box>

        <Flex justifyContent="flex-end" paddingX="16px" paddingTop="12px" paddingBottom="28px">
          <Button
            variant="outlineDark"
            onClick={() => {
              props.onClose()
            }}
          >
            Ok
          </Button>
        </Flex>
      </Stack>
      <Box></Box>
    </Modal>
  )
}
